
// Ref: https://stackoverflow.com/questions/31626852/how-to-add-konami-code-in-a-website-based-on-html

var keyCodes = {
	32: 'space',
  37: 'left',
  38: 'up',
  39: 'right',
  40: 'down',
	48: '0',
	49: '1',
	50: '2',
	51: '3',
	52: '4',
	53: '5',
	54: '6',
	55: '7',
	56: '8',
	57: '9',
  65: 'a',
  66: 'b',
	67: 'c',
	68: 'd',
	69: 'e',
	70: 'f',
	71: 'g',
	72: 'h',
	73: 'i',
	74: 'j',
	75: 'k',
	76: 'l',
	77: 'm',
	78: 'n',
	79: 'o',
	80: 'p',
	81: 'q',
	82: 'r',
	83: 's',
	84: 't',
	85: 'u',
	86: 'v',
	87: 'w',
	88: 'x',
	89: 'y',
	90: 'z'
};




function doCustomKonamiCode(customKonamiCode, customKonamiFunction) {

	// a variable to remember the 'position' the user has reached so far.
	var konamiCodePosition = 0;

	// add keydown event listener
	document.addEventListener('keydown', function(e) {
	  // get the value of the key code from the key map
	  var key = keyCodes[e.keyCode];
	  // get the value of the required key from the konami code
	  var requiredKey = customKonamiCode[konamiCodePosition];
	  // compare the key with the required key
	  if (key == requiredKey) {
	    // move to the next key in the konami code sequence
	    konamiCodePosition++;
	    // if the last key is reached, activate cheats
	    if (konamiCodePosition == customKonamiCode.length) {
	      customKonamiFunction();
	      konamiCodePosition = 0;
	    }
	  } else {
	    konamiCodePosition = 0;
	  }
	});

}
